import { ActionType } from "../types/invoiceTypes";
export var getInvoice = function () { return ({
    type: ActionType.GET_INVOICE,
}); };
export var getInvoiceSuccess = function (invoice) { return ({
    type: ActionType.GET_INVOICE_SUCCESS,
    payload: invoice,
}); };
export var getInvoiceClear = function (invoice) { return ({
    type: ActionType.GET_INVOICE_CLEAR,
    payload: invoice,
}); };
export var getInvoiceError = function (error) { return ({
    type: ActionType.GET_INVOICE_ERROR,
    payload: error,
}); };
